/* HEGEMON — global.js */
(function () {
  // Mobile menu
  var burger = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant picker (product page)
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  var jsonEl = document.querySelector('[data-product-json]');
  if (!jsonEl) return;
  var product = JSON.parse(jsonEl.textContent);
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-price]');
  var comparePriceEl = document.querySelector('[data-compare-price]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var addBtnText = addBtn ? addBtn.querySelector('span') : null;

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'de', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function selectedOptions() {
    var opts = [];
    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) opts[parseInt(group.dataset.optionIndex, 10)] = checked.value;
    });
    return opts;
  }

  function update() {
    var opts = selectedOptions();
    var variant = product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; if (addBtnText) addBtnText.textContent = addBtn.dataset.textUnavailable; }
      return;
    }
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = money(variant.compare_at_price);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addBtnText) {
        addBtnText.textContent = variant.available ? addBtn.dataset.textAdd : addBtn.dataset.textSoldout;
      }
    }
  }

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"]')) update();
  });
  update();
})();
